import {
    handleEnabledIconMouseEnter as handleEnabledMouseEnter,
    handleEnabledIconMouseLeave as handleEnabledMouseLeave,
    handleIconMouseEnter,
    handleIconMouseLeave,
    uiStyles
} from 'lib/uiUtils';
import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    FormControl,
    InputAdornment,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    FiberPinRounded,
    VisibilityOffOutlined,
    VisibilityOutlined,
    VerifiedUserOutlined
} from '@material-ui/icons';
import theme from 'theme';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { validateComboFields } from 'lib/configUtils';
import { MODULO_POR_PREFIXO_ROTA } from 'permissionsCatalog';
import { ComboPadrao, FormActions, FormStatusSwitch } from 'views/Components';
import { generateRandomPwd, getCodUsuarioRegistrou, isMissingValue } from 'lib/functions';

class UsuarioForm extends Component {
    handleIconMouseEnter = handleIconMouseEnter;
    handleIconMouseLeave = handleIconMouseLeave;
    safeSetState = safeSetState;

    state = {
        usuario: {
            codusuario: '',
            usuario: '',
            senha: '',
            codfuncionario: '',
            inativo: ANAO
        },
        confirmPwd: '',
        errors: {},
        openAlert: false,
        messageAlert: '',
        funcionarios: [],
        isNewRecord: false,
        isView: false,
        permissoesRascunho: [],
        showPwd: false,
        showConfirmPwd: false,
        schema: {
            usuario: {
                presence: {
                    allowEmpty: false,
                    message: 'Nome do usuário obrigatório!'
                },
                length: { maximum: 50 },
                type: 'string'
            },
            senha: {
                presence: {
                    allowEmpty: false,
                    message: 'Senha obrigatória!'
                },
                length: { maximum: 8 },
                type: 'string'
            },
            codfuncionario: {
                presence: {
                    allowEmpty: false,
                    message: 'Funcionário obrigatório!'
                },
                length: { maximum: 100 },
                type: 'integer'
            }
        }
    };

    _isMounted = false;

    /* Eventos dos ícones condicionados ao modo de visualização */
    // ao passar o cursor
    handleIconMouseEnter = (event) => {
        handleEnabledMouseEnter(event, this.state.isView);
    };

    // ao remover o cursor
    handleIconMouseLeave = (event) => {
        handleEnabledMouseLeave(event, this.state.isView);
    };

    /* Alterna a visibilidade da senha */
    handleToggleShowPassword = () => {
        const { isView } = this.state;

        if (!isView) {
            this.setState(prevState => ({
                showPwd: !prevState.showPwd
            }));
        }
    };

    /* Alterna a visibilidade da confirmação de senha */
    handleToggleShowConfirmPassword = () => {
        const { isView } = this.state;

        if (!isView) {
            this.setState(prevState => ({
                showConfirmPwd: !prevState.showConfirmPwd
            }));
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                const { location } = this.props;

                await this.loadFuncionarios();

                const rascunho = location?.state || {};

                this.safeSetState({
                    isNewRecord: true,
                    isView: false,
                    usuario: rascunho.usuario || this.getUsuarioDefault(),
                    confirmPwd: rascunho.confirmPwd || '',
                    permissoesRascunho: rascunho.permissoesRascunho || []
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadFuncionarios(id);
                await this.loadUsuario(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar usuário:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar usuário!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna o usuário padrão */
    getUsuarioDefault = () => ({
        codusuario: '',
        usuario: '',
        senha: '',
        codfuncionario: '',
        inativo: ANAO
    });

    /* Carrega os funcionários */
    loadFuncionarios = async (codfuncionario) => {
        const url = codfuncionario
            ? `/funcionario/listforchange/${codfuncionario}`
            : '/funcionario/active/true';

        const response = await api.get(url);

        this.safeSetState({ funcionarios: getResponseData(response) });
    };

    /* Carrega o usuário */
    loadUsuario = async (id, isView) => {
        const response = await api.get(`/usuario/${id}`);
        const dados = getRecordFromResponse(response) || {};

        this.safeSetState({
            usuario: {
                ...dados,
                inativo: dados.inativo || ANAO,
                codfuncionario: dados.codfuncionario ?? ''
            },
            confirmPwd: dados.senha || '',
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { usuario } = this.state;
        const { name, value, checked } = event.target;

        let newValue = value;

        if (name === 'usuario') {
            newValue = value.toUpperCase();
        }

        if (name === 'senha' || name === 'confirmPwd') {
            newValue = value.toUpperCase();
        }

        if (name === 'inativo') {
            newValue = checked ? ANAO : ASIM;
        }

        if (name === 'confirmPwd') {
            this.setState({ confirmPwd: newValue });

            return;
        }

        this.setState({
            usuario: {
                ...usuario,
                [name]: newValue
            }
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o código do módulo ativo a partir do caminho da rota */
    getModuloAtivo = () => {
        const prefixo = this.props.match?.path?.split('/')[1] || '';

        return MODULO_POR_PREFIXO_ROTA[prefixo];
    };

    /* Retorna o payload de usuário */
    getPayloadUsuario = () => {
        const { usuario } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();

        if (isMissingValue(codusuarioregistrou)) {
            throw new Error('Código do usuário não encontrado!');
        }

        return {
            codfuncionario: usuario.codfuncionario || '',
            usuario: usuario.usuario || '',
            senha: usuario.senha || '',
            inativo: usuario.inativo || ANAO,
            codusuarioregistrou
        };
    };

    /* Salva o usuário e retorna codusuario */
    salvarUsuario = async ({ skipValidation = false } = {}) => {
        const { confirmPwd, isNewRecord, permissoesRascunho, usuario } = this.state;
        const { loadUsuario } = this.props;

        if (!skipValidation) {
            const errors = this.validationRequiredFields();

            this.setState({ errors });

            if (Object.keys(errors).length > 0) {
                this.handleOpenAlert('Verifique os campos obrigatórios!');

                return null;
            }

            if ((usuario.senha || '') !== (confirmPwd || '')) {
                this.setState(prevState => ({
                    errors: {
                        ...prevState.errors,
                        confirmPwd: 'As senhas não coincidem!'
                    }
                }));

                this.handleOpenAlert('As senhas não coincidem!');

                return null;
            }

            const comboErrors = validateComboFields(
                usuario,
                [
                    {
                        field: 'codfuncionario',
                        message: 'Selecione um funcionário válido!'
                    }
                ]
            );

            if (Object.keys(comboErrors).length > 0) {
                this.setState(prevState => ({
                    errors: {
                        ...prevState.errors,
                        ...comboErrors
                    }
                }));

                this.handleOpenAlert('Selecione um funcionário válido!');

                return null;
            }
        }

        try {
            const payload = this.getPayloadUsuario();
            let codusuario = usuario.codusuario;

            if (isNewRecord) {
                const response = await api.post('/usuario', payload);
                codusuario = response?.data?.codusuario;

                this.setState(prevState => ({
                    usuario: {
                        ...prevState.usuario,
                        codusuario
                    },
                    isNewRecord: false
                }));

                if (permissoesRascunho.length > 0) {
                    try {
                        await api.put(`/usuario/permissoes/${codusuario}`, {
                            codmodulo: this.getModuloAtivo(),
                            permissions: permissoesRascunho
                        });

                        this.setState({ permissoesRascunho: [] });
                    } catch (permError) {
                        console.error(
                            'Erro ao salvar permissões do novo usuário:',
                            permError.response?.data || permError.message
                        );

                        this.handleOpenAlert(`
                            Usuário criado, mas houve um erro ao salvar as permissões marcadas.
                            Defina-as novamente em Permissões!
                        `);

                        return null;
                    }
                }
            } else {
                await api.put(`/usuario/${usuario.codusuario}`, payload);
            }

            if (loadUsuario) loadUsuario();

            return codusuario;
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );

            return null;
        }
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const codusuario = await this.salvarUsuario();

        if (codusuario) {
            this.props.history.push(this.getBasePath());
        }
    };

    /* Caminho base da tela */
    getBasePath = () => {
        const path = this.props.match?.path || '/front/usuario/:id';
        return path.replace('/:id', '');
    };

    /* Retorna o código do usuário a partir da URL */
    getCodUsuario = () => this.props.match?.params?.id;

    /* Clicar para abrir as permissões do usuário */
    onClickPermissoes = () => {
        const { history } = this.props;
        const { confirmPwd, isNewRecord, permissoesRascunho, usuario } = this.state;
        const codusuario = this.getCodUsuario();

        if (isNewRecord) {
            history.push({
                pathname: `${this.getBasePath()}/novo/permissoes`,
                state: {
                    usuario,
                    confirmPwd,
                    permissoesRascunho
                }
            });

            return;
        }

        history.push(`${this.getBasePath()}/${codusuario}/permissoes`);
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push(this.getBasePath());
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schema, usuario } = this.state;

        return validateSchemaFields(
            usuario,
            schema,
            [
                'usuario',
                'senha',
                'codfuncionario'
            ]
        );
    };

    /* Gera a senha */
    onClickGeneratePassword = () => {
        const { isView } = this.state;

        if (!isView) {
            this.handleGeneratePwd();
        }
    };

    /* Gera uma senha aleatória */
    handleGeneratePwd = () => {
        const pwd = generateRandomPwd(8);

        this.setState(prev => ({
            usuario: {
                ...prev.usuario,
                senha: pwd
            },
            confirmPwd: pwd
        }));
    };

    render() {
        const {
            confirmPwd,
            errors,
            funcionarios,
            isNewRecord,
            isView,
            messageAlert,
            openAlert,
            showConfirmPwd,
            showPwd,
            usuario
        } = this.state;

        const { actionIcon } = uiStyles;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Usuário {usuario.codusuario}
                        </Typography>

                        <Box
                            display="flex"
                            alignItems="center"
                            style={{ gap: 10 }}
                        >
                            <Tooltip title="Permissões">
                                <VerifiedUserOutlined
                                    onClick={this.onClickPermissoes}
                                    onMouseEnter={this.handleIconMouseEnter}
                                    onMouseLeave={this.handleIconMouseLeave}
                                    style={{
                                        ...actionIcon,
                                        fontSize: 28
                                    }}
                                />
                            </Tooltip>

                            <FormStatusSwitch
                                checked={usuario.inativo !== ASIM}
                                name="inativo"
                                onChange={this.onChange}
                                disabled={isView}
                            />
                        </Box>
                    </Box>

                    <br />

                    <Box>
                        <TextField
                            label="Nome do usuário"
                            name="usuario"
                            value={usuario.usuario || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.usuario || ''}
                            error={!!errors.usuario}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            fullWidth
                        />
                    </Box>

                    <br />

                    <Box>
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            fullWidth
                            style={{
                                flex: '0 1 400px',
                                minWidth: 300
                            }}
                        >
                            <ComboPadrao
                                name={'codfuncionario'}
                                label={'Funcionário'}
                                value={usuario.codfuncionario}
                                onChange={this.onChange}
                                fieldId={'codfuncionario'}
                                listItems={funcionarios}
                                fieldDescription={'nome'}
                                helperText={errors.codfuncionario || ''}
                                error={!!errors.codfuncionario}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        alignItems="flex-start"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="Senha"
                            name="senha"
                            value={usuario.senha || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type={showPwd ? 'text' : 'password'}
                            autoComplete={isNewRecord ? 'new-password' : 'current-password'}
                            helperText={errors.senha || ''}
                            error={!!errors.senha}
                            disabled={isView}
                            inputProps={{ maxLength: 8 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title="Ver/ocultar senha">
                                            <span>
                                                {showPwd ? (
                                                    <VisibilityOffOutlined
                                                        onClick={this.handleToggleShowPassword}
                                                        onMouseEnter={this.handleIconMouseEnter}
                                                        onMouseLeave={this.handleIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                ) : (
                                                    <VisibilityOutlined
                                                        onClick={this.handleToggleShowPassword}
                                                        onMouseEnter={this.handleIconMouseEnter}
                                                        onMouseLeave={this.handleIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                )}
                                            </span>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                            style={{
                                flex: 1,
                                minWidth: 160
                            }}
                        />

                        <TextField
                            label="Confirmar senha"
                            name="confirmPwd"
                            value={confirmPwd || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type={showConfirmPwd ? 'text' : 'password'}
                            autoComplete={isNewRecord ? 'new-password' : 'current-password'}
                            helperText={errors.confirmPwd || ''}
                            error={!!errors.confirmPwd}
                            disabled={isView}
                            inputProps={{ maxLength: 8 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip title="Ver/ocultar senha">
                                            <span>
                                                {showConfirmPwd ? (
                                                    <VisibilityOffOutlined
                                                        onClick={this.handleToggleShowConfirmPassword}
                                                        onMouseEnter={this.handleIconMouseEnter}
                                                        onMouseLeave={this.handleIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                ) : (
                                                    <VisibilityOutlined
                                                        onClick={this.handleToggleShowConfirmPassword}
                                                        onMouseEnter={this.handleIconMouseEnter}
                                                        onMouseLeave={this.handleIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                )}
                                            </span>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                            style={{
                                flex: 1,
                                minWidth: 160
                            }}
                        />

                        <Tooltip title="Gerar senha">
                            <FiberPinRounded
                                onClick={this.onClickGeneratePassword}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={{
                                    fontSize: 32,
                                    color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                    cursor: isView ? 'default' : 'pointer',
                                    marginTop: 12
                                }}
                            />
                        </Tooltip>
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

UsuarioForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadUsuario: PropTypes.func
};

export default UsuarioForm;